import { IonicModule } from '@ionic/angular';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PrivacyPolicyPage } from './privacy-policy.page';
import { ComponentsModule } from 'src/app/components/components.module';
import { SharedModule } from 'src/app/shared/shared/shared.module';


const homeRoutes: Routes = [
  {
    path: '',
    component: PrivacyPolicyPage
  }
];

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    ComponentsModule,
    SharedModule,
    RouterModule.forChild(homeRoutes),
  ],
  declarations: [
    PrivacyPolicyPage
  ],
  providers: [
  ]
})
export class PrivacyPolicyPageModule {}
